import { ClerkProvider } from "@clerk/react"
import { PostHogProvider } from "@posthog/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { AppRouter } from "@/app-router"
import { BRAND_NAME } from "@/lib/brand"
import { installPreloadErrorReload } from "@/lib/preload-error-listener"
import { queryClient } from "@/lib/query-client"
import { initPostHog, posthog } from "@/lib/posthog"
import { initBrowserSentry } from "@/lib/sentry"

import "./index.css"

if (import.meta.env.DEV) {
	const worktree = import.meta.env.VITE_WORKTREE
	document.title = worktree ? `${worktree} · ${BRAND_NAME}` : `${BRAND_NAME} (Dev)`
}

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!publishableKey) {
	throw new Error("VITE_CLERK_PUBLISHABLE_KEY is not set (repo root .env for Compose, or frontend/.env.local for host pnpm dev — see README)")
}

initBrowserSentry()
initPostHog()
// Module scope, before render: StrictMode double-mounts effects, but this runs exactly once.
installPreloadErrorReload()


createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<PostHogProvider client={posthog}>
			<ClerkProvider publishableKey={publishableKey} signInUrl="/sign-in" signUpUrl="/sign-up" afterSignOutUrl="/sign-in">
				<QueryClientProvider client={queryClient}>
					<AppRouter />
				</QueryClientProvider>
			</ClerkProvider>
		</PostHogProvider>
	</StrictMode>
)
